import Box from "@mui/material/Box"
import SinapThemev2 from "../styles/SinapThemev2"
import { ThemeProvider } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import Divider from "@mui/material/Divider"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material/styles"

import ArchivoListas from "./ArchivoListas"

export default function Archivos() {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <Box>
      <ThemeProvider theme={SinapThemev2}>
        <Typography fontSize={matches ? "28px" : "30px"} my="40px" mx="10px">
          Archivos de la Secretaria Administrativa
        </Typography>
        <ArchivoListas />
      </ThemeProvider>
    </Box>
  )
}
